import React from "react";
import CustomModal from "../CustomModal/CustomModal";
import { allSharedComponents } from "../../../shared";

const ChangePasswordModal = (props) => {
  const { GeneralLogo, BaseForm, ChangePassword } = allSharedComponents;

  return (
    <>
      <CustomModal
        size="sm"
        scrollable={true}
        setShow={props.setShow}
        show={props.isShow}
        closeBtnClasses={"login-modal-close-btn"}
      >
        <BaseForm>
          <GeneralLogo />
          <ChangePassword setShow={props.setShow} />
        </BaseForm>
      </CustomModal>
    </>
  );
};

export default ChangePasswordModal;
